import { Core } from "@faire/design-tokens";
import { ISimpleTextTile } from "@faire/web-api/indigofair/data/ISimpleTextTile";
import { isNotUndefined } from "@faire/web/common/typescriptUtils";
import { getSpacing } from "@faire/web/slate/spacing";
import { TypographyStyles } from "@faire/web/slate/Typography";
import React from "react";
import { Link } from "react-router-dom";
import styled from "styled-components";

import { Context } from "@faire/retailer/components/LayoutElementRenderer/__internal__/Context";

import { BaseCarouselProps } from "../CarouselBase";

import { FiniteCarouselBase } from "./FiniteCarouselBase";

export const SquaredCategoryCarousel: React.FC<BaseCarouselProps> = () => {
  const { layoutElement, onItemClick, requestId } = React.useContext(Context);
  const layoutElementData = layoutElement.layout_element_data ?? [];
  const pillData = layoutElementData
    .map((layout) => layout["simple_text_tile"])
    .filter(isNotUndefined);

  const onItemClickHandler = (categoryPath: string | undefined) => {
    const { on_click_event_name } = layoutElement;
    if (on_click_event_name && categoryPath) {
      onItemClick?.(on_click_event_name, requestId, categoryPath);
    }
  };

  const renderItem = (textTile: ISimpleTextTile, index: number) => {
    const { on_click_event_name } = layoutElement;
    const { main_text, cta_link } = textTile;

    if (cta_link === undefined) {
      return null;
    }

    return (
      <Pill
        to={cta_link}
        key={`${on_click_event_name}-${index}`}
        onClick={() => {
          onItemClickHandler(cta_link);
        }}
      >
        {main_text}
      </Pill>
    );
  };

  return <FiniteCarouselBase items={pillData} renderItem={renderItem} />;
};

const Pill = styled(Link)`
  ${TypographyStyles({ as: undefined })}
  flex-shrink: 0;
  background: ${Core.surface.muted};
  border-radius: 4px;
  margin: ${getSpacing(0, "1x", 0, 0)};
  padding: ${getSpacing("1x", "2x")};
  text-align: center;
`;
